import CarouselMediaItem from './CarouselMediaItem';

export default CarouselMediaItem;
